export default function FAQAction() {
  const faqs = document.querySelectorAll(
    ".faq-item",
  ) as NodeListOf<HTMLDivElement>;
  if (faqs) {
    faqs.forEach((faq) => {
      faq.addEventListener("click", function (e) {
        if (e.target.closest(".faq-item-text")) {
          return;
        }
        e.preventDefault();
        if (faq.classList.contains("active")) {
          faq.classList.remove("active");
          return;
        }
        faqs.forEach((faq) => {
          faq.classList.remove("active");
        });

        this.classList.add("active");
      });
    });
  }
}
